<template>
    <div class="container">
        <h1>História porúch</h1>

        <div class="row">
            <div class="col-md-3">
                <v-text-field
                    v-model="search"
                    label="Vyhľadávanie"
                    single-line
                    hide-details
                ></v-text-field>
            </div>
        </div>

        <v-data-table
            :headers="headers"
            :items="defects"
            :items-per-page="20"
            :footer-props="{
                'items-per-page-options': [5, 10, 20, 50]
            }"
            :search="search"
            class="elevation-1"
            loading
            :sort-by="['point.rvo']"
            :sort-desc="[false]"
            multi-sort
            loading-text="Načítavam..."
        >
            <template v-slot:item.point.sortName="{ item }">
                <router-link
                    :to="{
                        name: 'dashboard',
                        params: {
                            mapType: 'defect',
                            point: item.point.name.replace('/', '')
                        },
                    }"
                    title="Zobraziť svetelný bod na mape"
                    class="btn btn-link"
                >
                    {{ item.point.name }}
                </router-link>
            </template>

            <template v-slot:item.created_at="{ item }">
                <span>{{ item.created_at | moment("DD.MM.YYYY HH:mm:ss") }}</span>
            </template>

            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{ name: 'defectsHistoryDetail', params: { id: item.point_id } }"
                    class="btn btn-outline-primary btn-sm"
                >
                    <font-awesome-icon :icon="['fas', 'eye']" />
                </router-link>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import api from "../../store/api";

export default {
    name: "Defects",
    data() {
        return {
            search: "",
            defects: [],
            solutionFilter: "",
            typeFilter: "",
            typeOptions: [],
            userFilter: "",
            userOptions: [],
        };
    },
    mounted() {
        api.get(`/reported/history`)
            .then(response => {
                this.defects = response.data;
            })
            .catch(error => {
                alert(error);
            });
    },
    computed: {
        headers() {
            return [
                {
                    text: "Svetelný bod",
                    align: "left",
                    value: "point.sortName",
                    sortable: false
                },
                {
                    text: "Rozvádzač",
                    align: "left",
                    value: "point.rvo"
                },{
                    text: "Číslo svietidla",
                    align: "left",
                    value: "point.nameId"
                },
                { text: "", value: "action", sortable: false }
            ];
        }
    }
};
</script>

<style scoped>
.material-icons {
    display: none;
}
</style>
